import React, { createContext, useState, useContext } from "react";

const AllContext = createContext();

// Custom hook para consumir el contexto fácilmente
export const useAllContext = () => useContext(AllContext);

const AllProvider = ({ children }) => {
  const [isOpenNav, setIsOpenNav] = useState(false);
  const [homeBgChangeService, setHomeBgChangeService] = useState(false)

  return (
    <AllContext.Provider value={{ isOpenNav, setIsOpenNav,homeBgChangeService, setHomeBgChangeService }}>
      {children}
    </AllContext.Provider>
  );
};

export { AllProvider };